/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { CancelApplicationValues } from './cancelApplicationModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'cancel-application-modal',
    standalone: false,
})
export class CancelApplicationModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: CancelApplicationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('cancelApplicationModal', elementRef, injector);
    }
}
